import { types } from 'mobx-state-tree';
export default function readonlyType(typeName) {
    return types.custom({
        name: typeName,
        fromSnapshot: function (snapshot) {
            return snapshot;
        },
        toSnapshot: function (snapshot) {
            return snapshot;
        },
        isTargetType: function (_value) {
            return true;
        },
        getValidationMessage: function (snapshot) {
            return JSON.stringify(snapshot) + " doesn't look like a valid " + typeName;
        }
    });
}
//# sourceMappingURL=ReadonlyType.js.map